namespace Solovis.Reports.Parts.Tables.DataTableHelpers {

    export class RowDataExporter {

        public tableControl: Solovis.Reports.Parts.Tables.DataTableControl;
        public _persistedSettings;

        constructor(options) {
            this.tableControl = options.tableControl;
            this._persistedSettings = options.persistedSettings;
        }

        public getPartControl() {
            return this.tableControl;
        }

        public getReportControl() {
            return this.tableControl.reportControl;
        }

        public getElementName() {
            // TODO: Add way to store element name on the table control.
            var reportControl = this.getReportControl();
            var elementNameList = reportControl.getElementNameList();
            for (var i = 0; i < elementNameList.length; i++) {
                var elementName = elementNameList[i];
                var partControl = reportControl.getReportPartControl(elementName);
                if (partControl === this.tableControl) {
                    return elementName;
                }
            }

            return null;
        }

        public getPersistedSettings() {
            return Solovis.deepCopy(this._persistedSettings);
        }

        public setFilteredColumnIds(filteredColumnIds: string[]) {
            if (!this._persistedSettings) {
                this._persistedSettings = {};
            }

            this._persistedSettings.filteredColumnIds = filteredColumnIds;            
        }

        public getFilteredColumnIds(): string[] {
            if (this._persistedSettings) {
                return this._persistedSettings.filteredColumnIds;
            }
            else {
                return null;
            }
        }

        /**
         * Retrieve which rows should be exported. If this is set to "RawData",
         * the source data rows for the table will be exported. If this is set
         * to "CurrentView", the currently visible group and data rows
         * will be exported in the order they appear.
         */
        public getRowMode() {
            if (this._persistedSettings) {
                if (Solovis.isNotNull(this._persistedSettings.rowMode)) {
                    return this._persistedSettings.rowMode;
                }
            }

            return "RawData";
        }

        public setRowMode(rowMode) {
            if (!this._persistedSettings) {
                this._persistedSettings = {};
            }

            this._persistedSettings.rowMode = rowMode;
        }

        public getExportMetadata() {            
            let fullExportMetadata = this.getFullExportMetadata();

            let filteredColumnIds = this.getFilteredColumnIds();
            if (_.isEmpty(filteredColumnIds)) {
                return fullExportMetadata;
            }
            else {                
                let entryIdToEntryMap = {};
                for (let co = 0; co < fullExportMetadata.exportColumns.length; co++) {
                    let exportColumn = fullExportMetadata.exportColumns[co];
                    let columnValueGetter = fullExportMetadata.columnValueGetters[co];

                    let entry = {
                        exportColumn: exportColumn,
                        columnValueGetter: columnValueGetter
                    };

                    entryIdToEntryMap[exportColumn.id] = entry;
                }

                let exportMetadataToUse = {
                    exportColumns: [],
                    columnValueGetters: []
                };

                for (let filteredColumnId of filteredColumnIds) {
                    let entry = entryIdToEntryMap[filteredColumnId];
                    
                    if (entry) {
                        exportMetadataToUse.exportColumns.push(entry.exportColumn);
                        exportMetadataToUse.columnValueGetters.push(entry.columnValueGetter);
                    }
                    else {
                        // Add empty placeholder for missing column to preserve column position.
                        exportMetadataToUse.exportColumns.push({
                            id: filteredColumnId,
                            comboLabel: "MISSING : " + filteredColumnId,
                            label: filteredColumnId
                        });
                        exportMetadataToUse.columnValueGetters.push({
                            rowValueGetter: function () { return null; },
                            rowTextGetter: function () { return null; }
                        });
                    }
                }

                return exportMetadataToUse;
            }
        }


        private addSpecialGroupColumns(exportColumns, columnValueGetters) {
            let self = this;

            let rowContextGetter = function (rowModel) {
                let cellContext = {
                    rowModel: rowModel
                };
            };

            // __isGroup
            exportColumns.push({
                id: "__isGroup",
                label: "::Is Group",
                comboLabel: "::Is Group",
                dataType: "bool"
            });
            columnValueGetters.push({
                rowContextGetter: rowContextGetter,
                rowValueGetter: function (rowModel) {
                    return rowModel.isGroupHeader ? true : null;
                },
                rowTextGetter: function (cellValue, cellContext) {
                    return cellValue ? "Group" : "";
                }
            });

            // __groupLabel
            exportColumns.push({
                id: "__groupLabel",
                label: "::Group Label",
                comboLabel: "::Group Label",
                dataType: "string"
            });
            columnValueGetters.push({
                rowContextGetter: rowContextGetter,
                rowValueGetter: function (rowModel) {
                    if (rowModel.isGroupHeader) {
                        return self.getGroupRowHeaderText(rowModel);
                    }
                    else {
                        return null;
                    }
                },
                rowTextGetter: function (cellValue, cellContext) {
                    return cellValue ? cellValue.toString() : "";
                }
            });

            // __groupLevel
            exportColumns.push({
                id: "__groupLevel",
                label: "::Group Level",
                comboLabel: "::Group Level",
                dataType: "integer"
            });
            columnValueGetters.push({
                rowContextGetter: rowContextGetter,
                rowValueGetter: function (rowModel) {
                    if (Solovis.isNotNull(rowModel.level)) {
                        return rowModel.level;
                    }
                    else {
                        return null;
                    }
                },
                rowTextGetter: function (cellValue, cellContext) {
                    return cellValue ? cellValue.toString() : "";
                }
            });
        }

        public getFullExportMetadata() {
            var self = this;

            var exportColumns = [];
            var columnValueGetters = [];

            let rowMode = this.getRowMode();
            if (rowMode === "CurrentView" && !_.isEmpty(this.tableControl.groupManager.getGroupByList())) {
                // We also need to define export columns for the custom grouping.
                this.addSpecialGroupColumns(exportColumns, columnValueGetters);
            }

            var columnList = this.tableControl.columnSet.getColumnList();

            $(columnList).each(function (i, colObject: any) {
                var col = colObject.definitionToUse;

                var exportCol: any = {
                    id: col.id,
                    label: col.label,
                    sourceColumnId: col.id
                };

                if (col.exportDataType) {
                    exportCol.dataType = col.exportDataType;
                }
                else if (col.dataType) {
                    exportCol.dataType = col.dataType;
                }

                if (col.superHeaders) {
                    exportCol.superHeaders = Solovis.deepCopy(col.superHeaders);
                }

                if (col.tagSetId) {
                    exportCol.tagSetId = col.tagSetId;
                }

                let rowContextGetter = function (rowModel): any {
                    if (rowModel.isGroupHeader) {
                        let actualRow = rowModel.row;

                        let cellContext: any = {
                            reportControl: self.tableControl.reportControl,
                            row: actualRow,
                            level: rowModel.level,
                            modelEnvironment: self.tableControl.modelEnvironment,
                            col: col,
                            defaultFormatter: Solovis.Reports.Formatter.formatValueAsHtml
                        };

                        if (actualRow._groupId === col.id) {
                            var group = self.tableControl.groupManager.getGroupById(actualRow._groupId);
                            cellContext.group = group;
                        }

                        return cellContext;
                    }
                    else {
                        let cellContext = {
                            reportControl: self.tableControl.reportControl,
                            dataTable: self.tableControl,
                            row: rowModel.row,
                            level: 0,
                            groupRowIndex: 0,
                            modelEnvironment: self.tableControl.modelEnvironment,
                            col: col,
                            defaultFormatter: Solovis.Reports.Formatter.formatValueAsHtml
                        };

                        return cellContext;
                    }
                };

                var rowValueGetter = function (rowModel) {
                    let cellValue = self.internalGetColumnValueForRowModel(col, rowModel);
                    return cellValue;
                };

                var rowTextGetter = function (cellValue, cellContext) {
                    var cellValueHtml = self.tableControl._formatCellHtml(cellValue, cellContext);
                    if (cellValueHtml) {
                        var textContent = cellValueHtml.textContent;
                        if (typeof textContent === "string") {
                            return textContent;
                        }
                        else if (cellValueHtml.text && typeof cellValueHtml.text === "function") {
                            let textArray = [];

                            // Grab text from individual divs (up to 2 down from top) as separate items.
                            let lookForText = (jElement, depth) => {
                                if (depth > 2) {
                                    let elementText = $(jElement).text();
                                    if (elementText && elementText.trim()) {
                                        textArray.push(elementText.trim());
                                    }
                                }
                                else {
                                    let childDivs = $(jElement).children('div');
                                    if (!childDivs || childDivs.length == 0) {
                                        let elementText = $(jElement).text();
                                        if (elementText && elementText.trim()) {
                                            textArray.push(elementText.trim());
                                        }
                                    }
                                    else {
                                        $(childDivs).each(function (i, childDiv) {
                                            lookForText($(childDiv), depth + 1);
                                        });
                                    }
                                }
                            };

                            lookForText($(cellValueHtml), 0);                            

                            if (textArray && textArray.length > 0) {
                                if (textArray.length == 1) {
                                    return textArray[0];
                                }
                                else {                                    
                                    return textArray;
                                }
                            }
                            else {
                                return cellValueHtml.text();
                            }
                        }
                        else if (typeof cellValueHtml === "string") {
                            return $("<div>").html(cellValueHtml).text();
                        }
                        else {
                            return cellValueHtml.toString();
                        }
                    }
                    else {
                        return null;
                    }
                };

                var exportRowValueGetter = null;
                var exportRowTextGetter = null;
                if (col.exportGetter) {
                    exportRowValueGetter = function (rowModel) {
                        return col.exportGetter(rowModel.row);
                    };
                    exportRowTextGetter = function (cellValue, cellContext) {
                        if (Solovis.isNotNull(cellValue))
                            return "" + cellValue;

                        return null;
                    };
                }


                var valueGetter = {
                    rowContextGetter: rowContextGetter,
                    rowValueGetter: rowValueGetter,
                    rowTextGetter: rowTextGetter
                };

                if (exportCol.dataType == "integer"
                    || exportCol.dataType == "currency"
                    || exportCol.dataType == "percentage"
                    || exportCol.dataType == "dayId"
                    || exportCol.dataType == "string"
                    || exportCol.dataType == "number") {

                    // We want to use the export row getter for these data types.
                    if (exportRowValueGetter) {
                        valueGetter.rowValueGetter = exportRowValueGetter;
                        valueGetter.rowTextGetter = exportRowTextGetter;
                    }

                    exportColumns.push(exportCol);
                    columnValueGetters.push(valueGetter);
                }
                else {
                    self._addStringExportColumn(exportColumns, columnValueGetters, exportCol, valueGetter);

                    // The remaining custom columns should all use the export getters if available.
                    var exportValueGetter = valueGetter;
                    if (exportRowValueGetter) {
                        exportValueGetter = Solovis.deepCopy(valueGetter);
                        exportValueGetter.rowValueGetter = exportRowValueGetter;
                        exportValueGetter.rowTextGetter = exportRowTextGetter;
                    }

                    // See if we should add extra columns for underlying data.
                    if (exportCol.dataType == "entityId"
                        || exportCol.dataType == "investmentId"
                        || exportCol.dataType == "currencyId"
                        || exportCol.dataType == "userId"
                        || exportCol.dataType == "tagId"
                        || exportCol.dataType == "propertyDefinitionId") {

                        self._addIdExportColumn(exportColumns, columnValueGetters, exportCol, exportValueGetter);
                    }

                    if (exportCol.dataType == "tagId" && exportCol.tagSetId) {
                        // Create extra columns for tag levels.
                        var tagSet = self.tableControl.modelEnvironment.tagSets.tryGetById(exportCol.tagSetId);
                        if (tagSet && tagSet.maxLevel > 0) {
                            // We need to create a column for each tag level label and name.
                            for (var levelCo = 0; levelCo <= tagSet.maxLevel; levelCo++) {
                                self._addTagLevelExportColumnForLabel(exportColumns, columnValueGetters, exportCol, exportValueGetter, tagSet, levelCo);
                            }

                            for (var levelCo = 0; levelCo <= tagSet.maxLevel; levelCo++) {
                                self._addTagLevelExportColumnForId(exportColumns, columnValueGetters, exportCol, exportValueGetter, tagSet, levelCo);
                            }
                        }
                    }
                }
            });

            var comboLabelCounters = {};
            $(exportColumns).each(function (i, exportCol: any) {
                var comboLabel = self._getComboLabel(exportCol);
                if (!comboLabelCounters[comboLabel]) {
                    comboLabelCounters[comboLabel] = 1;
                }
                else {
                    var nextCount = comboLabelCounters[comboLabel] + 1;
                    comboLabel += " (" + nextCount + ")";
                    comboLabelCounters[comboLabel] = nextCount;
                }

                exportCol.comboLabel = comboLabel;
            });

            var exportMetadata = {
                exportColumns: exportColumns,
                columnValueGetters: columnValueGetters
            };

            return exportMetadata;
        }


        public _getComboLabel(exportCol) {
            var comboLabel = "";
            if (exportCol.superHeaders) {
                for (var i = exportCol.superHeaders.length - 1; i >= 0; i--) {
                    comboLabel += exportCol.superHeaders[i] + " : ";
                }

                comboLabel += exportCol.label;
            }
            else {
                comboLabel = exportCol.label;
            }

            return comboLabel;
        };

        public _addStringExportColumn(exportColumns, columnValueGetters, exportCol, valueGetter) {
            var newExportCol = Solovis.deepCopy(exportCol);
            newExportCol.dataType = "string";

            var newValueGetter = Solovis.deepCopy(valueGetter);
            newValueGetter.rowValueGetter = function (row) {
                var cellContext = valueGetter.rowContextGetter(row);
                var cellValue = valueGetter.rowValueGetter(row);
                var text = valueGetter.rowTextGetter(cellValue, cellContext);
                return text;
            };
            newValueGetter.rowTextGetter = function (cellValue, cellContext) {
                return cellValue;
            };

            exportColumns.push(newExportCol);
            columnValueGetters.push(newValueGetter);
        };

        public _addIdExportColumn(exportColumns, columnValueGetters, exportCol, valueGetter) {
            var newExportCol = Solovis.deepCopy(exportCol);
            newExportCol.id = exportCol.id + "_id";
            newExportCol.label = exportCol.label + " (" + exportCol.dataType + ")";
            newExportCol.dataType = "integer";

            var newValueGetter = Solovis.deepCopy(valueGetter);
            newValueGetter.rowTextGetter = function (cellValue, cellContext) {
                if (Solovis.isNotNull(cellValue)) {
                    return "" + cellValue;
                }
                else {
                    return null;
                }
            };

            exportColumns.push(newExportCol);
            columnValueGetters.push(newValueGetter);
        };


        public _addTagLevelExportColumnForLabel(exportColumns, columnValueGetters, exportCol, valueGetter, tagSet, level) {
            var newExportCol = Solovis.deepCopy(exportCol);
            newExportCol.id = exportCol.id + "_level" + level;
            newExportCol.label = exportCol.label + " - Level " + level;
            newExportCol.dataType = "string";

            var newValueGetter = Solovis.deepCopy(valueGetter);
            newValueGetter.rowValueGetter = function (rowModel) {
                var tagId = valueGetter.rowValueGetter(rowModel);
                var tag = tagSet.tryGetTagById(tagId);
                if (tag) {
                    if (tag.level <= level) {
                        return tag.label;
                    }
                    else {
                        var levelTag = tag.getLevel(level);
                        if (levelTag) {
                            return levelTag.label;
                        }
                    }
                }

                return null;
            };

            newValueGetter.rowTextGetter = function (cellValue, cellContext) {
                if (Solovis.isNotNull(cellValue)) {
                    return cellValue;
                }
                else {
                    return null;
                }
            };

            exportColumns.push(newExportCol);
            columnValueGetters.push(newValueGetter);
        };

        public _addTagLevelExportColumnForId(exportColumns, columnValueGetters, exportCol, valueGetter, tagSet, level) {
            var newExportCol = Solovis.deepCopy(exportCol);
            newExportCol.id = exportCol.id + "_level" + level + "_id";
            newExportCol.label = exportCol.label + " - Level " + level + " (tagId)";
            newExportCol.dataType = "integer";

            var newValueGetter = Solovis.deepCopy(valueGetter);
            newValueGetter.rowValueGetter = function (rowModel) {
                var tagId = valueGetter.rowValueGetter(rowModel);
                var tag = tagSet.tryGetTagById(tagId);
                if (tag) {
                    if (tag.level <= level) {
                        return tag.id;
                    }
                    else {
                        var levelTag = tag.getLevel(level);
                        if (levelTag) {
                            return levelTag.id;
                        }
                    }
                }

                return null;
            };

            newValueGetter.rowTextGetter = function (cellValue, cellContext) {
                if (Solovis.isNotNull(cellValue)) {
                    return "" + cellValue;
                }
                else {
                    return null;
                }
            };

            exportColumns.push(newExportCol);
            columnValueGetters.push(newValueGetter);
        };


        public enumerateRows(exportMetadata, rowCallback) {
            let rowMode = this.getRowMode();

            if (rowMode === "RawData") {
                this.enumerateRawDataRows(exportMetadata, rowCallback);
            }
            else if (rowMode === "CurrentView") {
                this.enumerateCurrentViewRows(exportMetadata, rowCallback);
            }
            else {
                throw "Unexpected rowMode: " + rowMode;
            }
        }

        private enumerateRawDataRows(exportMetadata, rowCallback) {
            var self = this;

            var collectValuesForRow = function (i, actualRow, subRowIndex?) {
                var row = actualRow;
                if (actualRow._backingRow) {
                    row = actualRow._backingRow;
                }
                let rowModel = { row: actualRow };

                let rowValues = [];
                let rowTextValues = [];

                $(exportMetadata.columnValueGetters).each(function (colIndex, valueGetter: any) {
                    var cellValue = null;
                    var cellText = null;

                    try {
                        var cellContext = valueGetter.rowContextGetter(rowModel);
                        cellValue = valueGetter.rowValueGetter(rowModel);
                        cellText = valueGetter.rowTextGetter(cellValue, cellContext);
                    }
                    catch (ex) {
                        var msg = "Error getting cell value for export. colIndex: " + colIndex + ", row: " + i;
                        if (typeof subRowIndex !== "undefined") {
                            msg += ", sub-row: " + subRowIndex;
                        }
                        console.log(msg);
                    }

                    rowValues.push(cellValue);
                    rowTextValues.push(cellText);
                });

                rowCallback(rowValues, rowTextValues);

                // See if we need to check for dynamically generated sub-rows.
                if (self.tableControl._subRowFactory) {
                    var subRows = self.tableControl._subRowFactory.call(self.tableControl, row);
                    if (!_.isEmpty(subRows)) {
                        $(subRows).each(function (subRowIndex, subRow) {
                            collectValuesForRow(i, subRow, subRowIndex);
                        });
                    }
                }
            };

            if (this.tableControl.dataView) {
                $(this.tableControl.dataView.rows).each(function (i, row: any) {
                    collectValuesForRow(i, row);
                });
            }
        }

        private enumerateCurrentViewRows(exportMetadata, rowCallback) {
            var self = this;

            var collectValuesForRowModel = function (i, rowModel, subRowIndex?) {
                if (rowModel.isAggregateRow) {
                    return;
                }

                var row = rowModel.row;
                if (row._backingRow) {
                    row = row._backingRow;
                }

                var rowValues = [];
                var rowTextValues = [];

                $(exportMetadata.columnValueGetters).each(function (colIndex, valueGetter: any) {
                    var cellValue = null;
                    var cellText = null;

                    try {
                        var cellContext = valueGetter.rowContextGetter(rowModel);
                        cellValue = valueGetter.rowValueGetter(rowModel);
                        cellText = valueGetter.rowTextGetter(cellValue, cellContext);
                    }
                    catch (ex) {
                        var msg = "Error getting cell value for export. colIndex: " + colIndex + ", row: " + i;
                        if (typeof subRowIndex !== "undefined") {
                            msg += ", sub-row: " + subRowIndex;
                        }
                        console.log(msg);
                    }

                    rowValues.push(cellValue);
                    rowTextValues.push(cellText);
                });

                rowCallback(rowValues, rowTextValues);                
            };

            if (this.tableControl.dataView) {
                $(this.tableControl.dataView.flattenedRows).each(function (i, rowModel: any) {
                    collectValuesForRowModel(i, rowModel);
                });
            }
        };


        private internalGetColumnValueForRowModel(col: DataTableHelpers.Column, rowModel) {
            // NOTE: This is a duplicate of method on DataTableSeriesProcessor. Revisit to refactor this.

            let self = this;

            if (!col || !rowModel) {
                return null;
            }

            if (rowModel.isGroupHeader) {
                let actualRow = rowModel.row;

                var cellValueGetter;
                if (actualRow._backingRow) {
                    cellValueGetter = function (row, col) {
                        var cellValue = self.tableControl._getColumnValueForRow(col, row._backingRow);
                        return cellValue;
                    };
                }
                else {
                    cellValueGetter = function (row, col) {
                        var cellValue = row._groupTotals ? row._groupTotals[col.id] : null;
                        return cellValue;
                    };
                }

                if (col.id == actualRow._groupId) {
                    var group = this.tableControl.groupManager.getGroupById(actualRow._groupId);
                    if (group) {
                        let cellContext = {
                            reportControl: this.tableControl.reportControl,
                            row: actualRow,
                            level: rowModel.level,
                            modelEnvironment: this.tableControl.modelEnvironment,
                            group: group,
                            defaultFormatter: Solovis.Reports.Formatter.formatValueAsHtml
                        };

                        var groupRep = actualRow._groupRep;
                        var groupHeaderHtml = this.tableControl._formatCellHtml(groupRep, cellContext);
                        if (groupHeaderHtml === null || groupHeaderHtml === "")
                            groupHeaderHtml = "[Unknown]";

                        let cellText = $("<div>").html(groupHeaderHtml).text();
                        return cellText;
                    }
                    else {
                        return null;
                    }
                }
                else {
                    var cellValue = cellValueGetter(rowModel.row, col);
                    return cellValue;
                }
            }
            else {
                let actualRow = rowModel.row;

                var cellValue = this.tableControl._getColumnValueForRow(col, actualRow);
                return cellValue;
            }
        }

        private getGroupRowHeaderText(rowModel) {
            let self = this;

            if (rowModel.isGroupHeader) {
                let actualRow = rowModel.row;

                var group = this.tableControl.groupManager.getGroupById(actualRow._groupId);
                if (group) {
                    let cellContext = {
                        reportControl: this.tableControl.reportControl,
                        row: actualRow,
                        level: rowModel.level,
                        modelEnvironment: this.tableControl.modelEnvironment,
                        group: group,
                        defaultFormatter: Solovis.Reports.Formatter.formatValueAsHtml
                    };

                    var groupRep = actualRow._groupRep;
                    var groupHeaderHtml = this.tableControl._formatCellHtml(groupRep, cellContext);
                    if (groupHeaderHtml === null || groupHeaderHtml === "")
                        groupHeaderHtml = "[Unknown]";

                    let cellText = $("<div>").html(groupHeaderHtml).text();
                    return cellText;
                }
                else {
                    return null;
                }              
            }
            else {
                return null;
            }
        }
    }
}
